import EnumClass, { build } from '../EnumClass';
import data, { PartOfSpeechId, PartOfSpeechData } from './data';
import * as Translations from './translations';

export class PartOfSpeech extends EnumClass<PartOfSpeechId, PartOfSpeechData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: PARTS_OF_SPEECH,
  getById: getPartOfSpeechById,
  marshaller: PartOfSpeechMarshaller,
} = build<PartOfSpeechId, PartOfSpeechData, PartOfSpeech>('PartOfSpeechEnum', data, PartOfSpeech);
